'use client';
import { useNotifications } from '@/store';
import React from 'react';

const Notifications = () => {
	const notifications = useNotifications();

	return (
		<div className="fixed top-[70px] right-0 z-[2000000] flex flex-col  ">
			{notifications.map(({ id, component }) => (
				<React.Fragment key={id}>{component}</React.Fragment>
			))}
		</div>
		// <div className="fixed bottom-[70px] right-0 z-[2000000] flex flex-col bg-red-500 ">
		// 	{notifications.map(({ id, component }) => (
		// 		<React.Fragment key={id}>{component}</React.Fragment>
		// 	))}
		// </div>
	);
};

export default Notifications;
